<template>
  <div class="choose-product">
    <h2 class="step-title subtitle is-2 is-centered">
      <div class="step-title-number color-is-primary">
        1.
      </div>
      <div class="step-title-left" v-text="$t('organize-course.choose')" />
      <div class="step-title-center">
        <i
          class="fa fa-book color-is-primary is-hidden-mobile"
          aria-hidden="true"
        />
      </div>
      <div class="step-title-right" v-text="$t('organize-course.course')" />
    </h2>

    <div v-if="!product">
      <div class="field mt-3 mb-3">
        <p class="control is-expanded">
          <input
            v-model="query"
            :placeholder="
              $t('organize-course.start-typing-to-search-for-course')
            "
            class="input is-medium is-centered"
          />
        </p>
      </div>

      <div class="products mt-2">
        <div
          v-for="(p, index) in products"
          :key="index"
          class="columns product-row narrow mb-2"
        >
          <div class="column is-1 product-row-image">
            <figure class="image is-16by9">
              <img :src="p.images['16by9']" />
            </figure>
          </div>
          <div class="column product-row-desc">
            <div class="title" v-text="p.name" />
          </div>
          <div
            class="column is-1 has-grey-background
                        is-flex-center is-flex cursor-is-pointer"
            @click="choose(p)"
          >
            <i class="material-icons color-is-white font-is-2">
              check
            </i>
          </div>
        </div>

        <p v-if="products.length" class="help-text is-right">
          <small>
            <i class="fa fa-exclamation-circle color-is-warning" />
            <em v-text="$t('organize-course.help-choose-course')" />
          </small>
        </p>
      </div>
    </div>

    <div v-if="product">
      <div class="products mt-2">
        <div class="columns product-row narrow mb-2">
          <div class="column is-1 product-row-image">
            <figure class="image is-16by9">
              <img :src="product.images['16by9']" />
            </figure>
          </div>
          <div class="column product-row-desc">
            <div class="title" v-text="product.name" />
          </div>
          <div class="column is-1 has-blue-background is-flex-center is-flex">
            <i class="material-icons color-is-white font-is-2">
              check
            </i>
          </div>
          <div
            class="column is-1 has-red-background
                    is-flex-center is-flex cursor-is-pointer"
          >
            <i class="material-icons color-is-white font-is-2" @click="remove">
              delete
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import Api from 'api/products';

export default {
  name: 'ChooseProgram',

  props: {
    assigned_product: { type: Object, default: null }
  },

  data() {
    return {
      api: new Api(),
      query: '',
      products: [],
      product: this.assigned_product
    };
  },

  watch: {
    query(query) {
      this.search(query);
    }
  },

  created() {
    VueEventHub.$on('assign-product', product => {
      this.product = product;
    });
  },

  mounted() {
    this.search('');
  },

  methods: {
    search: debounce(function search(query) {
      this.api
        .search(query, 'course')
        .then(response => {
          this.products = response.data;
        })
        .catch(() => {});
    }, 300),

    choose(product) {
      VueEventHub.$emit('product-is-chosen', product);
      this.product = product;
    },

    remove() {
      VueEventHub.$emit('product-deleted');
      this.product = null;
    }
  }
};
</script>
